import { Route, Routes } from 'react-router-dom'
import VisitReportPage from './Page'

export default function VisitReportIndex() {
  return (
    <Routes>
      <Route path="/" element={<VisitReportPage />} />
    </Routes>
  )
}
